import { Fragment, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Impersonate,
  ImpersonateData,
  showOpenArea as showOpenAreaFromCommonAuth,
  showAdminMenu,
  showDevTools as showDevToolsFromCommonAuth,
  showOrganizationSettings as showOrganizationSettingsFromCommonAuth,
  showSensorList as showSensorListFromCommonAuth,
  EnvironmentSwitcher,
} from '@densityco/lib-common-auth';

import { useAppSelector } from 'redux/store';
import Navbar from 'deprecation/navbar';
import { useTreatments } from 'contexts/treatments';
import { SPLITS } from 'lib/treatments';
import { DeprecationBanner } from 'deprecation/deprecation-banner';

// This component fetches all the stuff about path and whatnot
// that the navbar component will need
export default function NavbarWrapper() {
  const history = useHistory();

  const user = useAppSelector((state) => state.user);
  const tokenCheckResponse = useAppSelector(
    (state) => state.auth.tokenCheckResponse
  );

  const userData = user.data;

  const onChangeImpersonatedUser = useCallback(
    (data: ImpersonateData) => {
      history.push('/');
      history.go(0);
    },
    [history]
  );

  const treatments = useTreatments(Object.values(SPLITS));

  const showDeprecationBanner = treatments[SPLITS.DEPRECATION_BANNER] === 'on';

  const showSpaces = treatments[SPLITS.VIEW_SPACES] === 'on';
  const showAnalytics = treatments[SPLITS.VIEW_ANALYTICS] === 'on';
  const showDashboards = treatments[SPLITS.VIEW_DASHBOARDS] === 'on';
  const showLive = treatments[SPLITS.VIEW_LIVE] === 'on';
  const showDisplays = treatments[SPLITS.VIEW_DISPLAYS] === 'on';
  const showOpenArea =
    treatments[SPLITS.VIEW_OPEN_AREA] === 'on' &&
    showOpenAreaFromCommonAuth(userData);

  const showLocationsMenu = treatments[SPLITS.MENU_LOCATIONS] === 'on';
  const showUserManagementMenu =
    treatments[SPLITS.MENU_USER_MANAGEMENT] === 'on';
  const showIntegrationsMenu = treatments[SPLITS.MENU_INTEGRATIONS] === 'on';
  const showDeveloperMenu =
    treatments[SPLITS.MENU_DEVELOPER] === 'on' &&
    showDevToolsFromCommonAuth(userData);
  const showOrganizationSettingsMenu =
    treatments[SPLITS.MENU_ORGANIZATION_SETTINGS] === 'on' &&
    showOrganizationSettingsFromCommonAuth(userData);
  const showSensorStatusMenu =
    treatments[SPLITS.MENU_SENSOR_STATUS] === 'on' &&
    showSensorListFromCommonAuth(userData);
  const showAccountMenu = treatments[SPLITS.MENU_ACCOUNT] === 'on';

  return (
    <Fragment>
      {showDeprecationBanner && <DeprecationBanner />}
      <Navbar
        path={window.location.toString()}
        environmentSwitcher={
          <EnvironmentSwitcher
            enabled={
              tokenCheckResponse?.permissions.includes('impersonate') || false
            }
          />
        }
        impersonate={<Impersonate onChange={onChangeImpersonatedUser} />}
        onPrem={false}
        showSpaces={showSpaces}
        showAnalytics={showAnalytics}
        showDashboards={showDashboards}
        showLive={showLive}
        showDisplays={showDisplays}
        showOpenArea={showOpenArea}
        showAdminMenu={showAdminMenu(userData)}
        showLocationsMenu={showLocationsMenu}
        showUserManagementMenu={showUserManagementMenu}
        showIntegrationsMenu={showIntegrationsMenu}
        showDeveloperMenu={showDeveloperMenu}
        showOrganizationSettingsMenu={showOrganizationSettingsMenu}
        showSensorStatusMenu={showSensorStatusMenu}
        showAccountMenu={showAccountMenu}
      />
    </Fragment>
  );
}
